import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Autocomplete,
  TextField,
  Button,
  Box,
  Typography,
  Chip,
  Grid,
  Divider,
  Checkbox,
  Dialog,
  AutocompleteChangeReason,
  AutocompleteChangeDetails,
  FormControlLabel,
  Tooltip,
} from "@mui/material";
import debounce from "lodash.debounce";
import axios from "axios";
import CustomAutocomplete from "../../../../autocomplete-field";
import { Bounce, toast } from "react-toastify";
import DynamicTable from "../../../../Dynamic-table";
import MedicineDoses, {
  MedicineDose,
} from "../../../../OPD/add-patient-record/MedicineDoses";
import AddNewTestProc from "../../../../OPD/add-patient-record/AddNewTestProc";
import {
  fetchSymptoms,
  selectSymptoms,
} from "../../../../../redux/reducers/OPD/Admin/symptomsSlice";
import {
  fetchSigns,
  selectSigns,
} from "../../../../../redux/reducers/OPD/Admin/signsSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import RulesRegulationModal from "./Rules&Regulation";
import dayjs from "dayjs";
import SignatureCanvas from "react-signature-canvas";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import FingerprintCaptureControls from "../../../../FingerprintCaptureControls";
import { useFingerprintCapture } from "../../../../../hooks/useFingerprintCapture";

interface PreSurgicalProps {
  onChange: (data: any) => void;
  data: any;
  otherTabsData: any;
  profile: any;
  opdData: any;
}

interface ConsentFormData {
  patientName: string;
  operationName: string;
  complications: string;
  alternatives: string;
  doctorName: string;
  signerName: string;
  relationship: string;
  signature: string;
  dateTime: string;
  doctorNameField: string;
}

const PreSurgical: React.FC<PreSurgicalProps> = ({
  onChange,
  data,
  otherTabsData,
  profile,
  opdData,
}) => {
  const [formData, setFormData] = useState<any>({
    pre_Operation: {
      npo: true,
      maintain_IV_Line: true,
      prepare_Area: true,
      take_Special_Consent: true,
      consent: {}, // Initialize as empty object for consent data
    },
    medicines: [],
    symptoms: [],
    diagnosis: [],
    signs: [], // Corrected typo from 'sings'
    Surgeon: {},
    anaesthetist: {},
    OTA: {},
  });
  const [selectedSurgeon, setSelectedSurgeon] = useState<any>("");
  const [allDiagnosis, setAllDiagnosis] = useState<any[]>([]);
  const [selectedDiagnosis, setSelectedDiagnosis] = useState<any>([]);
  const [diagnosisName, setDiagnosisNames] = useState<any[]>([]);
  const [searchDiagnosis, setSearchDiagnosis] = useState<any>("");
  const [inputValueDiagnosis, setInputValueDiagnosis] = React.useState("");
  const [preMedicine, setPreMedicine] = useState<any>();
  const [medicineData, setMedicineData] = useState<MedicineDose[]>([]);
  const [selectedPrevTests, setSelectedPrevTests] = useState<any[]>([]);
  const [openTestModal, setOpenTestModal] = useState(false);
  const [prevSelectedDiagnosis, setPrevSelectedDiagnosis] = useState<any>([]);
  const [allSymptoms, setAllSymptoms] = useState<any[]>([]);
  // const [selectedSymptoms, setSelectedSymptoms] = useState<string[]>([]);
  const [selectedSymptoms, setSelectedSymptoms] = useState<
    (string | { symptomName: string })[]
  >([]);
  const [selectedPrevSymptoms, setSelectedPrevSymptoms] = useState<string[]>(
    []
  );
  const [inputValue, setInputValue] = React.useState("");
  const [allSigns, setAllSigns] = useState<any[]>([]);
  const [selectedSigns, setSelectedSigns] = useState<any[]>([]);
  const [signNames, setSignNames] = useState<any[]>([]);
  const [selectedPrevSigns, setSelectedPrevSigns] = useState<any[]>([]);
  const [inputValueSigns, setInputValueSigns] = React.useState("");
  const [SurgeonOptions, setSurgeonOptions] = React.useState<any[]>([]);
  const [AnaesthetistOptions, setAnaesthetistOptions] = React.useState<any[]>(
    []
  );
  const [OTOptions, setOTOptions] = React.useState<any[]>([]);
  const [routeAdm, setRouteAdm] = useState<any>();
  const signs = useSelector(selectSigns);
  const dispatch = useDispatch();
  const signatureRef = useRef<SignatureCanvas | null>(null);
  const [signatureData, setSignatureData] = useState<string | null>(null);
  const [openConsentModal, setOpenConsentModal] = useState(false);
  const [consentSubmitted, setConsentSubmitted] = useState(false);

  // Add doctor signature refs and state
  const doctorSignatureRef = useRef<SignatureCanvas | null>(null);
  const [doctorSignatureData, setDoctorSignatureData] = useState<string | null>(
    null
  );

  // New state for consent form data
  const [consentFormData, setConsentFormData] = useState<ConsentFormData>({
    patientName: "",
    operationName: "",
    complications: "",
    alternatives: "",
    doctorName: "",
    signerName: "",
    relationship: "",
    signature: "",
    dateTime: dayjs().format("YYYY-MM-DDTHH:mm"),
    doctorNameField: "",
  });

  const handleFingerprintCaptured = useCallback((fingerprintDataUrl: string) => {
    signatureRef.current?.clear();
    setSignatureData(fingerprintDataUrl);
    setConsentFormData(prev => ({
      ...prev,
      signature: fingerprintDataUrl,
    }));
  }, []);

  const handleDoctorFingerprintCaptured = useCallback(
    (fingerprintDataUrl: string) => {
      doctorSignatureRef.current?.clear();
      setDoctorSignatureData(fingerprintDataUrl);
    },
    []
  );

  const {
    fingerprintDevice,
    detectingDevice,
    capturingFingerprint,
    isFingerprintImage,
    setIsFingerprintImage,
    detectDevice,
    captureFingerprint,
    syncFingerprintFlag,
  } = useFingerprintCapture({ onCaptured: handleFingerprintCaptured });

  const {
    fingerprintDevice: doctorFingerprintDevice,
    detectingDevice: detectingDoctorDevice,
    capturingFingerprint: capturingDoctorFingerprint,
    isFingerprintImage: isDoctorFingerprintImage,
    setIsFingerprintImage: setIsDoctorFingerprintImage,
    detectDevice: detectDoctorDevice,
    captureFingerprint: captureDoctorFingerprint,
    syncFingerprintFlag: syncDoctorFingerprintFlag,
  } = useFingerprintCapture({ onCaptured: handleDoctorFingerprintCaptured });

  const clearSignature = () => {
    signatureRef.current?.clear();
    setSignatureData(null);
    setIsFingerprintImage(false);
    setConsentFormData(prev => ({
      ...prev,
      signature: "",
    }));
  };

  const clearDoctorSignature = () => {
    doctorSignatureRef.current?.clear();
    setDoctorSignatureData(null);
    setIsDoctorFingerprintImage(false);
  };

  // const [signatureData, setSignatureData] = useState<string>('');

  // const handleSignature = () => {
  //     const signature = signatureRef.current?.toDataURL() || null; // Fallback to null if undefined
  //     setSignatureData(signature);
  //     setConsentFormData((prev: any) => ({
  //         ...prev,
  //         concent: {
  //             ...prev.concent,
  //             consentForm: {
  //                 ...prev.extra.consentForm,
  //                 signature: signature,
  //             },
  //         },
  //     }));
  // };

  // const handleSignature= () => {
  //     const signature = signatureRef.current?.toDataURL('image/png') || null; // Fallback to null if undefined

  //     setSignatureData(signature); // Optional: If you're using this somewhere

  // //     setConsentFormData((prev: any) => ({
  // //         ...prev,
  // //         concent: {
  // //             ...prev.concent,
  // //             consentForm: {
  // //                 ...prev.concent?.consentForm,
  // //                 signature: signature,
  // //             },
  // //         },
  // //     }
  // // ));
  // console.log("Signature data:", signatureData);

  //     console.log("Signature captured:", signature);
  // };

  const handleSignature = () => {
    const signature = signatureRef.current?.toDataURL("image/png") || "";
    setIsFingerprintImage(false);
    setSignatureData(signature);
    setConsentFormData(prev => ({
      ...prev,
      signature,
    }));
  };

  const handleDoctorSignature = () => {
    const signature = doctorSignatureRef.current?.toDataURL("image/png") || "";
    setIsDoctorFingerprintImage(false);
    setDoctorSignatureData(signature);
  };

  // Handle changes in TextField inputs
  const handleConsentInputChange = (field: string, value: string) => {
    setConsentFormData(prev => ({
      ...prev,
      [field]:
        field === "dateTime" ? dayjs(value).format("YYYY-MM-DDTHH:mm") : value,
    }));
  };
  // Handle Submit button click
  // const handleConsentSubmit = () => {
  //     const signatureDataURL = handleSignature();
  //     console.log("svajhdvas", signatureDataURL)

  //     // Check if signature is empty
  //     if (!signatureData) {
  //         toast.error('Please provide a signature before submitting.');
  //         return;
  //     }

  //     // Validate dateTime
  //     if (!dayjs(consentFormData.dateTime).isValid()) {
  //         toast.error('Please provide a valid date and time.');
  //         return;
  //     }

  //     console.log("Consent signature data:", signatureData);
  //     const consentData = {
  //         patientName: consentFormData.patientName,
  //         operationName: consentFormData.operationName,
  //         complications: consentFormData.complications,
  //         alternatives: consentFormData.alternatives,
  //         doctorName: consentFormData.doctorName,
  //         signerName: consentFormData.signerName,
  //         relationship: consentFormData.relationship,
  //         signature: signatureData,
  //         dateTime: consentFormData.dateTime,

  //     };
  //     console.log("Signature data:", consentData);        // Store the consent data in pre_Operation.consent
  //     handlePreOperationChange('consent', consentData);

  //     onChange({
  //         ...formData,
  //         pre_Operation: {
  //             ...formData.pre_Operation,
  //             consent: consentData,
  //         },
  //         concent: consentData, // Fix typo: should be "consent" if intended
  //     });

  //     // Close the dialog
  //     setOpenConsentModal(false);

  //     // Assign values to consentFormData based on available data instead of clearing
  //     setConsentFormData({
  //         patientName: profile?.fullName || consentFormData.patientName || '', // Use patient name from profile if available
  //         operationName: opdData?.procedure || consentFormData.operationName || '', // Use procedure from opdData if available
  //         complications: consentFormData.complications || '', // Retain entered complications or empty
  //         alternatives: consentFormData.alternatives || '', // Retain entered alternatives or empty
  //         doctorName: formData?.Surgeon?.fullName || consentFormData.doctorName || '', // Use surgeon name if available
  //         signerName: profile?.fullName || consentFormData.signerName || '', // Use profile name for signer if available
  //         relationship: consentFormData.relationship || '', // Retain entered relationship or empty
  //         signature: consentFormData.signature || '', // Clear signature after submission
  //         dateTime: consentFormData.dateTime || dayjs().format('YYYY-MM-DDTHH:mm'),
  //     });

  //     // Clear the signature canvas
  //     clearSignature();

  // };
  const handleConsentSubmit = () => {
    // Check if signature already exists or get new signature
    const signature =
      signatureData ||
      (signatureRef.current?.isEmpty()
        ? ""
        : signatureRef.current?.toDataURL("image/png"));
    if (!signature) {
      toast.error("Please provide a signature before submitting.");
      return;
    }
    if (!dayjs(consentFormData.dateTime).isValid()) {
      toast.error("Please provide a valid date and time.");
      return;
    }

    // Check if doctor signature already exists or get new signature
    const doctorSignature =
      doctorSignatureData ||
      (doctorSignatureRef.current?.isEmpty()
        ? ""
        : doctorSignatureRef.current?.toDataURL("image/png"));

    if (!doctorSignature) {
      toast.error("Please provide doctor signature before submitting.");
      return;
    }

    const consentData = { ...consentFormData, signature, doctorSignature };

    handlePreOperationChange("consent", consentData);

    onChange({
      ...formData,
      pre_Operation: {
        ...formData.pre_Operation,
        consent: consentData,
      },
      consent: consentData,
    });

    setConsentFormData(consentData);
    setSignatureData(signature);
    setDoctorSignatureData(doctorSignature);
    setConsentSubmitted(true);
    setOpenConsentModal(false);
  };

  // Handle Cancel button click
  const handleConsentCancel = () => {
    setOpenConsentModal(false);
  };

  // useEffect(() => {
  //     if (signatureData && signatureRef.current) {
  //         signatureRef.current.clear();
  //         try {
  //             signatureRef.current.fromDataURL(signatureData, {
  //                 ratio: window.devicePixelRatio || 1,
  //             });
  //         } catch (error) {
  //             console.error('Error loading signature data:', error);
  //         }
  //     }
  // }, [signatureData, openConsentModal]); // Added openConsentModal to trigger on dialog open

  const fetchFormData = async (formName: string) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_IPD_API_URL}/ipd-form-data/getFormDataBySearchId/${otherTabsData?._id}?formName=${formName}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (formName === "Investegation") {
        setSelectedPrevTests(
          response?.data?.data?.formData?.investigation || []
        );
      } else {
        setPreMedicine(response?.data?.data?.formData?.medicines);
      }
    } catch (error) {
      toast.error("Failed to fetch form data.");
    }
  };

  useEffect(() => {
    fetchFormData("Treatment");
    fetchFormData("Investegation");
  }, []);
  const getAnaesthetist = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_ADMIN_API_URL}/users/getAllUserByCategoryName?categoryName=Anaesthetist`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response?.data?.isSuccess === true) {
        setAnaesthetistOptions(response?.data?.data);
      }
    } catch (err) {
      console.error("Error fetching anesthetist:", err);
    }
  };
  const getSurgeon = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_ADMIN_API_URL}/users/getAllUserByCategoryName?department=Surgeon&categoryName=Doctor`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response?.data?.isSuccess === true) {
        setSurgeonOptions(response?.data?.data);
      }
    } catch (err) {
      console.error("Error fetching anesthetist:", err);
    }
  };
  const getOT = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_ADMIN_API_URL}/users/getAllUserByCategoryName?categoryName=OT Incharge`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response?.data?.isSuccess === true) {
        setOTOptions(response?.data?.data);
      }
    } catch (err) {
      console.error("Error fetching anesthetist:", err);
    }
  };
  useEffect(() => {
    getAnaesthetist();
    getSurgeon();
    getOT();
  }, []);

  useEffect(() => {
    onChange({
      history: formData?.symptoms,
      examinations: formData?.signs,
      diagnosis: formData?.diagnosis,
      medicines: formData?.medicines,
      pre_Operation: formData?.pre_Operation,
      opd_diagnosis: prevSelectedDiagnosis,
      opd_history: selectedPrevSymptoms,
      opd_examination: selectedPrevSigns,
      OTA: formData?.OTA,
      Surgeon: formData?.Surgeon,
      anaesthetist: formData?.anaesthetist,
      consent: {
        ...consentFormData,
        doctorSignature: doctorSignatureData,
      },
    });
  }, [
    formData,
    prevSelectedDiagnosis,
    selectedPrevSymptoms,
    selectedPrevSigns,
    signatureData,
    doctorSignatureData,
  ]);

  const handleAnaesthetistChange = async (value: any) => {
    if (value !== formData?.anaesthetist) {
      const newUpdatedFormData = {
        ...formData,
        anaesthetist: value || null,
      };
      setFormData(newUpdatedFormData);
    }
  };

  const handleOTChange = async (value: any) => {
    if (value !== formData?.OTA) {
      const newUpdatedFormData = {
        ...formData,
        OTA: value || null,
      };
      setFormData(newUpdatedFormData);
    }
  };

  const handleSurgeonChange = async (value: any) => {
    // if (value !== formData?.Surgeon) {
    const newUpdatedFormData = {
      ...formData,
      Surgeon: value || null,
    };
    setFormData(newUpdatedFormData);

    setSelectedSurgeon(value?.fullName);
  };

  useEffect(() => {
    // Never spread a string — that turns one diagnosis into character chips.
    const asNameList = (val: unknown): string[] => {
      if (val == null || val === "") return [];
      if (typeof val === "string") {
        const t = val.trim();
        return t ? [t] : [];
      }
      if (!Array.isArray(val)) return [];
      if (
        val.length > 1 &&
        val.every((i) => typeof i === "string" && i.length === 1)
      ) {
        return [val.join("")];
      }
      return val
        .map((item) =>
          typeof item === "string"
            ? item.trim()
            : String(
                (item as any)?.diagnosisName || (item as any)?.name || ""
              ).trim()
        )
        .filter(Boolean);
    };
    const uniqueDiagnosis = Array.from(
      new Set([
        ...asNameList(opdData?.diagnosis),
        ...asNameList(otherTabsData?.diagnosis),
      ])
    );

    setPrevSelectedDiagnosis(uniqueDiagnosis);
    setSelectedPrevSymptoms(opdData?.symptoms || []);
    setSelectedPrevSigns(opdData?.signs || []);
  }, [opdData, otherTabsData]);

  useEffect(() => {
    if (data) {
      setFormData((prev: any) => ({
        ...prev,
        diagnosis: data?.diagnosis || [],
        medicines: data?.medicines || [],
        symptoms: data?.history || [],
        signs: data?.examinations || [],
        pre_Operation: {
          consent: data?.pre_Operation?.consent || {},
          npo: data?.pre_Operation?.npo ?? true,
          maintain_IV_Line: data?.pre_Operation?.maintain_IV_Line ?? true,
          shave: data?.pre_Operation?.shave || "",
          prepare_Area: data?.pre_Operation?.prepare_Area ?? true,
          take_Special_Consent:
            data?.pre_Operation?.take_Special_Consent ?? true,
        },
        Surgeon: data?.Surgeon || {},
        OTA: data?.OTA || {},
        anaesthetist: data?.anaesthetist || {},
      }));

      // Initialize consentFormData
      if (data?.consent) {
        // Fixed typo from 'concent'
        setConsentFormData({
          patientName: data?.consent?.patientName || "",
          operationName: data?.consent?.operationName || "",
          complications: data?.consent?.complications || "",
          alternatives: data?.consent?.alternatives || "",
          doctorName: data?.consent?.doctorName || "",
          signerName: data?.consent?.signerName || "",
          relationship: data?.consent?.relationship || "",
          signature: data?.consent?.signature || "",
          dateTime:
            data?.consent?.dateTime || dayjs().format("YYYY-MM-DDTHH:mm"),
          doctorNameField: data?.consent?.doctorNameField || "",
        });
        if (data?.consent?.signature) {
          setSignatureData(data?.consent?.signature);
        }
        if (data?.consent?.doctorSignature) {
          setDoctorSignatureData(data?.consent?.doctorSignature);
        }
      }

      setDiagnosisNames(data?.details?.diagnosis || []);
      if (data?.diagnosis) {
        setSelectedDiagnosis(data?.diagnosis);
        setDiagnosisNames(data?.diagnosis);
      }
      if (data?.medicines) {
        setMedicineData(data?.medicines);
      }
      if (Array.isArray(data?.history)) {
        setSelectedSymptoms(data?.history);
      } else {
        setSelectedSymptoms([]);
      }
      setSignNames(data?.examinations || []);
    } else {
      setFormData({
        pre_Operation: {
          npo: true,
          maintain_IV_Line: true,
          prepare_Area: true,
          take_Special_Consent: true,
          consent: {},
        },
        medicines: [],
        symptoms: [],
        diagnosis: [],
        signs: [],
        Surgeon: {},
        anaesthetist: {},
        OTA: {},
      });
    }
  }, [data]);

  const debouncedGetDiagnosis = useCallback(
    debounce(async (search: string) => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_OPD_API_URL}/diagnosis/getAllSelectAbleDiagnosis?search=${search}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        const fetchedDiagnosis = response?.data?.data || [];
        setAllDiagnosis(fetchedDiagnosis);
      } catch (error) {
        console.error(error);
      }
    }, 500),
    []
  );

  useEffect(() => {
    debouncedGetDiagnosis(searchDiagnosis);
  }, [debouncedGetDiagnosis, searchDiagnosis]);

  const sendAlertToStaff = async (
    staffType: string,
    staffId: string | undefined
  ) => {
    const allDiagnoses = Array.from(
      new Map(
        [...selectedDiagnosis, ...prevSelectedDiagnosis].map((item: any) => [
          item?._id || item,
          item,
        ])
      ).values()
    );
    if (!staffId) {
      toast.error(`Please select a valid ${staffType}.`);
      return;
    }
    const payload = {
      staffId,
      staff_type: staffType,
      admissionId: otherTabsData?._id,
      diagnosis: allDiagnoses,
      procedure: opdData?.procedure,
      expectedTimeOfProcedure: "2 hr",
      otName: "10",
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_IPD_API_URL}/operation-alert/sendAlertToStaff`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      // Use the message from the backend response for the success toast
      toast.success(
        response.data.message || `${staffType} alert sent successfully!`
      );
    } catch (error: any) {
      console.error("Error sending alert:", error);

      // Use the message from the backend error response if available
      const errorMessage =
        error.response?.data?.message || `Failed to send ${staffType} alert.`;
      toast.error(errorMessage);
    }
  };
  const handlePreOperationChange = (name: string, value: any) => {
    const updatedFormData = {
      ...formData,
      pre_Operation: {
        ...formData.pre_Operation,
        [name]: value,
      },
    };
    setFormData(updatedFormData);
  };

  const handleSelectChangeDiagnosis = (event: { target: { value: any } }) => {
    const selectedDiagnosisIds = event.target.value;
    const selectedDiagnosisObjects = allDiagnosis?.filter((diagnosis: any) =>
      selectedDiagnosisIds?.includes(diagnosis?._id)
    );
    setSelectedDiagnosis(selectedDiagnosisObjects);

    const newDiagnosisNames = selectedDiagnosisObjects
      .filter(
        (diagnosis: any) => !diagnosisName?.includes(diagnosis.diagnosisName)
      )
      .map((diagnosis: any) => diagnosis?.diagnosisName);
    const finalDiagnosis = [...diagnosisName, ...newDiagnosisNames];
    setDiagnosisNames(finalDiagnosis);
  };

  const handleDeleteChipDiagnosis = (diagnosisToDelete: string) => {
    setSelectedDiagnosis((prevSelectedDiagnosis: any) =>
      prevSelectedDiagnosis?.filter(
        (sign: any) => sign.diagnosisName !== diagnosisToDelete
      )
    );
    const newDiagnosisNames = diagnosisName.filter(
      (diagnosis: any) => diagnosis !== diagnosisToDelete
    );
    setDiagnosisNames(newDiagnosisNames);
    const newData = {
      details: {
        ...formData.details,
        diagnosis: selectedDiagnosis?.map((diag: any) => diag._id),
      },
    };
    // onChange(newData);
  };

  const handleCreateNewDiagnosis = async (inputValue: string) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_OPD_API_URL}/diagnosis/createDiagnosis`,
        { diagnosisName: inputValue },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const newDiagnosis = response?.data?.data;
      if (newDiagnosis) {
        setSelectedDiagnosis((prevSelected: any) => [
          ...prevSelected,
          newDiagnosis,
        ]);
        setDiagnosisNames(prevNames => [
          ...prevNames,
          newDiagnosis?.diagnosisName,
        ]);
        setSearchDiagnosis("");

        setAllDiagnosis((prevGenerics: any) => [...prevGenerics, newDiagnosis]);
        toast.success(response.data?.message);
      }
    } catch (error: any) {
      console.error("Error creating new diagnosis:", error);
      toast.error(error.message);
    }
  };
  useEffect(() => {
    setFormData((prevData: any) => ({
      ...prevData,
      diagnosis: diagnosisName,
    }));
    // onChange({ ...formData, diagnosis: diagnosisName });
  }, [diagnosisName]);

  const handleInputChangeDiagnosis = (
    event: any,
    newInputValue: React.SetStateAction<string>
  ) => {
    setInputValueDiagnosis(newInputValue);
    setSearchDiagnosis(newInputValue);
  };

  const handleInputChangeDiagnosisBlur = () => {
    setInputValueDiagnosis("");
    setSearchDiagnosis("");
  };

  const handleAddButtonClickDiagnosis = () => {
    if (inputValueDiagnosis.trim() !== "") {
      handleCreateNewDiagnosis(inputValueDiagnosis);
      setInputValueDiagnosis("");
    }
  };

  const handleKeyPressDiagnosis = (event: {
    key: string;
    preventDefault: () => void;
  }) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleAddButtonClickDiagnosis();
    }
  };

  const handleMedicineDoses = (medicineDoses: any[]) => {
    const updatedFormData: any = {
      ...formData,
      medicines: medicineDoses,
    };
    setFormData(updatedFormData);
    // onChange(updatedFormData);
  };

  const symptoms = useSelector(selectSymptoms);

  useEffect(() => {
    dispatch(fetchSymptoms(inputValue) as any);
  }, [dispatch, inputValue]);

  useEffect(() => {
    setAllSymptoms(symptoms);
  }, [symptoms]);

  const handleSelectChangeSymptoms = (
    event: React.SyntheticEvent<Element, Event>,
    value: any[],
    reason?: AutocompleteChangeReason,
    details?: AutocompleteChangeDetails<any> | undefined
  ) => {
    const selectedSymptomNames = value
      ?.map((symptom: any) => symptom?.symptomName)
      ?.filter((name: string | undefined) => name && name.trim() !== "");

    setSelectedSymptoms(prevSymptoms => {
      const prevSymptomsArray = Array.isArray(prevSymptoms) ? prevSymptoms : [];
      const newSymptoms = [
        ...prevSymptomsArray,
        ...selectedSymptomNames?.filter(
          name => !prevSymptomsArray.includes(name)
        ),
      ];
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        symptoms: newSymptoms,
      }));
      return newSymptoms;
    });
  };

  // useEffect(() => {
  //     onChange({
  //         ...formData,
  //         symptoms: formData?.symptoms
  //     });
  // }, [formData]);

  const handleDeleteChipSymptoms = (symptomToDelete: any) => {
    setSelectedSymptoms((prevSelectedSymptoms: any) =>
      prevSelectedSymptoms?.filter(
        (symptom: any) => symptom !== symptomToDelete
      )
    );
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      symptoms: prevFormData?.symptoms?.filter(
        (symptom: string) => symptom !== symptomToDelete
      ),
    }));
  };

  const handleCreateNewSymptoms = async (inputValue: string) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_OPD_API_URL}/symptoms/createSymptom?count='10000`,
        { symptomName: inputValue },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const newSymptoms = response.data?.data;
      if (newSymptoms) {
        setSelectedSymptoms((prevSelected: any) => [
          ...prevSelected,
          newSymptoms?.symptomName,
        ]);
        setFormData((prevFormData: any) => ({
          ...prevFormData,
          symptoms: newSymptoms?.symptomName,
        }));
        // onChange({ ...formData, symptoms: newSymptoms?.symptomName })
        dispatch(fetchSymptoms(inputValue) as any);
        setAllSymptoms(prevGenerics => {
          return Array.isArray(prevGenerics)
            ? [...prevGenerics, newSymptoms]
            : [newSymptoms];
        });
        toast.success(response.data?.message);
      }
    } catch (error: any) {
      console.error("Error creating new symptom:", error);
      toast.error(error.message);
    }
  };

  const handleInputChange = (event: any, newInputValue: any) => {
    setInputValue(newInputValue);
    dispatch(fetchSymptoms(newInputValue || "") as any);
  };

  const handleBlurSymptoms = () => {
    setInputValue("");
    dispatch(fetchSymptoms("") as any);
  };

  const handleAddButtonClick = () => {
    if (inputValue.trim() !== "") {
      handleCreateNewSymptoms(inputValue);
      setInputValue("");
    }
  };

  const handleKeyPress = (event: {
    key: string;
    preventDefault: () => void;
  }) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleAddButtonClick();
    }
  };

  useEffect(() => {
    setAllSigns(signs || []);
  }, [signs]);
  useEffect(() => {
    dispatch(fetchSigns(inputValueSigns) as any);
  }, [dispatch, inputValueSigns]);
  const handleCreateNewSigns = async (inputValue: string) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_OPD_API_URL}/signs/createSign`,
        { signName: inputValue },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const newSigns = response.data?.data;
      if (newSigns) {
        // setAllSigns((prevGenerics: any) => [...prevGenerics, newSigns]);
        setSelectedSigns((prevSelected: any) => [...prevSelected, newSigns]);

        setSignNames(prevNames => [...prevNames, newSigns.signName]);
        await dispatch(fetchSigns(inputValueSigns) as any);
        setAllSigns(prevSymptoms => [...prevSymptoms, newSigns]);
        toast.success(response.data?.message);
      }
    } catch (error: any) {
      console.error("Error creating new generic:", error);
      toast.error(error.message);
    }
  };
  const handleDeleteChip = (signToDelete: any) => {
    setSelectedSigns((prevSelectedSigns: any) =>
      prevSelectedSigns.filter((sign: any) => sign.signName !== signToDelete)
    );
    const newSignNames = signNames?.filter(
      (sign: any) => sign !== signToDelete
    );
    setSignNames(newSignNames);
  };
  useEffect(() => {
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      signs: signNames,
    }));
  }, [signNames]);
  // useEffect(() => {
  //     onChange({ ...formData, signs: formData?.signs });
  // }, [formData])

  // const handleSelectChangeSign = (event: { target: { value: any } }) => {
  //     const selectedSignIds = event.target.value;
  //     const selectedSignObjects = allSigns?.filter((sign: any) =>
  //         selectedSignIds?.includes(sign?._id)
  //     );
  //     setSelectedSigns(selectedSignObjects);

  //     const newSignNames = selectedSignObjects
  //         .filter((sign: any) => !signNames?.includes(sign?.signName))
  //         .map((sign: any) => sign?.signName);

  //     setSignNames([...signNames, ...newSignNames]);
  // };
  const handleSelectChangeSign = (event: { target: { value: any } }) => {
    const selectedSignIds = event.target.value;
    const selectedSignObjects = allSigns?.filter((sign: any) =>
      selectedSignIds?.includes(sign?._id)
    );
    setSelectedSigns(selectedSignObjects);

    const newSignNames = selectedSignObjects
      .filter((sign: any) => !signNames?.includes(sign?.signName))
      ?.map((sign: any) => sign?.signName);

    // Ensure signNames is always an array
    setSignNames([
      ...(Array.isArray(signNames) ? signNames : []),
      ...newSignNames,
    ]);
  };

  const handleInputChangeSigns = (event: any, newInputValue: any) => {
    setInputValueSigns(newInputValue);
    dispatch(fetchSigns(newInputValue || "") as any);
  };

  const handleInputChangeSignsBlur = () => {
    setInputValueSigns("");
    dispatch(fetchSigns("") as any);
  };

  const handleAddButtonClickSigns = () => {
    if (inputValueSigns.trim() !== "") {
      handleCreateNewSigns(inputValueSigns);
      setInputValueSigns("");
    }
  };

  const handleKeyPressSigns = (event: {
    key: string;
    preventDefault: () => void;
  }) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleAddButtonClickSigns();
    }
  };

  const getRouteAdm = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_OPD_API_URL}/routes-of-administration/getAllByPagination`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          count: 50000,
          pageNo: 1,
        },
      }
    );
    setRouteAdm(response?.data?.data);
  };
  useEffect(() => {
    getRouteAdm();
  }, []);

  useEffect(() => {
    if (data?.consent?.signature && data?.consent?.doctorSignature) {
      setConsentSubmitted(true);
    }
  }, [data?.consent?.signature, data?.consent?.doctorSignature]);
  return (
    <Box>
      <Grid container spacing={1}>
        <Grid item md={2.4} sm={3} xs={4}>
          <Box>
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "12px",
                color: "#000",
              }}
            >
              Prov. Diagnosis/DD:{" "}
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
              <Typography
                sx={{ fontSize: "10px", color: "#000", fontWeight: "500" }}
              >
                {otherTabsData?.finalDiagnosis && (
                  <Tooltip title="Final Diagnosis" placement="top">
                    <span
                      style={{
                        background: "#FFCCCB",
                        fontSize: "10px",
                        padding: "2px",
                        color: "#000",
                      }}
                    >
                      {otherTabsData?.finalDiagnosis}
                    </span>
                  </Tooltip>
                )}{" "}
                {prevSelectedDiagnosis?.slice(0, 2).join(", ")}
                {prevSelectedDiagnosis?.length > 2 && (
                  <Tooltip
                    title={prevSelectedDiagnosis?.slice(2)?.join(", ")}
                    arrow
                    placement="top"
                  >
                    <span style={{ cursor: "pointer", color: "#1976d2" }}>
                      +{prevSelectedDiagnosis?.length - 2} more
                    </span>
                  </Tooltip>
                )}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item md={2.4} sm={3} xs={4}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "12px",
              color: "#000",
            }}
          >
            Prev. Tests
          </Typography>
          <Box>
            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
              <Typography
                sx={{ fontSize: "10px", color: "#000", fontWeight: "500" }}
              >
                {(Array.isArray(selectedPrevTests) &&
                  selectedPrevTests
                    ?.slice(0, 2)
                    ?.map((test: any) => test?.investigation_Name)
                    .join(", ")) ||
                  "No Previous Tests"}
                {selectedPrevTests?.length > 2 && (
                  <Tooltip
                    placement="top"
                    title={
                      Array.isArray(selectedPrevTests) &&
                      selectedPrevTests
                        ?.slice(2)
                        ?.map((test: any) => test?.investigation_Name)
                        ?.join(", ")
                    }
                    arrow
                  >
                    <span style={{ cursor: "pointer", color: "#1976d2" }}>
                      {" "}
                      +{selectedPrevTests?.length - 2} more
                    </span>
                  </Tooltip>
                )}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item md={2.4} sm={3} xs={4}>
          <Typography sx={{ fontSize: "12px", fontWeight: "600" }}>
            Surgeon:
          </Typography>
          <CustomAutocomplete
            options={SurgeonOptions}
            value={formData?.Surgeon}
            onChange={(event, newValue) => handleSurgeonChange(newValue)}
            getOptionLabel={option => option?.fullName || ""}
            filterOptions={(options, { inputValue }) =>
              options.filter((option: any) =>
                option?.fullName
                  ?.toLowerCase()
                  .includes(inputValue.toLowerCase())
              )
            }
            placeholder="Select Surgeon"
          />
          <Button
            variant="contained"
            size="small"
            sx={{
              mt: 1,
              fontSize: "10px",
              width: "120px",
              height: "23px",
              padding: "4px 8px",
              backgroundColor: "#25D366",
              color: "#fff",
              gap: "5px",
              "&:hover": { backgroundColor: "#1DA859" },
              borderRadius: "4px",
            }}
            onClick={() => sendAlertToStaff("Surgeon", formData?.Surgeon?._id)} // Pass the Surgeon ID
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" // WhatsApp logo URL
              alt="WhatsApp Icon"
              style={{ width: "12px", height: "12px" }} // Adjust size of the icon
            />
            Send Request
          </Button>
        </Grid>

        <Grid item md={2.4} sm={3} xs={4}>
          <Typography sx={{ fontSize: "12px", fontWeight: "600" }}>
            Anaesthetist:
          </Typography>
          <CustomAutocomplete
            options={AnaesthetistOptions}
            value={formData?.anaesthetist || null}
            onChange={(event, newValue) => handleAnaesthetistChange(newValue)}
            getOptionLabel={option => option?.fullName || ""}
            filterOptions={(options, { inputValue }) =>
              options.filter((option: any) =>
                option?.fullName
                  ?.toLowerCase()
                  .includes(inputValue.toLowerCase())
              )
            }
            placeholder="Select Anaesthetist"
          />
          <Button
            variant="contained"
            sx={{
              mt: 1,
              gap: "5px",
              fontSize: "10px",
              width: "120px",
              height: "23px",
              padding: "4px 8px",
              backgroundColor: "#25D366",
              color: "#fff",
              "&:hover": { backgroundColor: "#1DA859" },
              borderRadius: "4px",
            }}
            onClick={() =>
              sendAlertToStaff("Anaesthetist", formData?.anaesthetist?._id)
            } // Pass only the ID to the function
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" // WhatsApp logo URL
              alt="WhatsApp Icon"
              style={{ width: "12px", height: "12px" }} // Adjust size of the icon
            />
            Send Request
          </Button>
        </Grid>

        <Grid item md={2.4} sm={3} xs={4}>
          {/* OT */}
          <Typography sx={{ fontSize: "12px", fontWeight: "600" }}>
            OTA:
          </Typography>
          <CustomAutocomplete
            options={OTOptions}
            value={formData?.OTA || null}
            onChange={(event, newValue) => handleOTChange(newValue)}
            getOptionLabel={option => option?.fullName || ""}
            filterOptions={(options, { inputValue }) =>
              options.filter((option: any) =>
                option?.fullName
                  ?.toLowerCase()
                  .includes(inputValue.toLowerCase())
              )
            }
            placeholder="Select OTA"
          />
          <Button
            variant="contained"
            sx={{
              mt: 1,
              fontSize: "10px",
              width: "120px",
              height: "23px",
              padding: "4px 8px",
              backgroundColor: "#25D366",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "5px",
              "&:hover": { backgroundColor: "#1DA859" },
              borderRadius: "4px",
            }}
            onClick={() => sendAlertToStaff("OT Incharge", formData?.OTA?._id)}
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
              alt="WhatsApp Icon"
              style={{ width: "12px", height: "12px" }}
            />
            Send Request
          </Button>
        </Grid>
      </Grid>

      <Typography sx={{ fontSize: "14px", fontWeight: "800", mt: 1 }}>
        Pre-Operation Checklist
      </Typography>
      <Grid container spacing={1}>
        <Grid item md={2.4} sm={4} xs={12}>
          <div
            style={{
              display: "flex",
              position: "relative",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                fontWeight: "600",
                fontSize: "12px",
                color: "#000",
              }}
            >
              Consent :{" "}
            </Typography>

            <Button
              variant="contained"
              size="small"
              onClick={() => {
                setOpenConsentModal(true);
                syncFingerprintFlag(consentFormData.signature);
                syncDoctorFingerprintFlag(doctorSignatureData);
                detectDevice(false);
                detectDoctorDevice(false);
              }}
              sx={{
                fontSize: "12px",
                backgroundColor: "#1976d2",
                height: "30px",
                width: "100%",
              }}
            >
              View Consent Form
            </Button>

            <Dialog
              open={openConsentModal}
              onClose={() => setOpenConsentModal(false)}
              maxWidth="md"
              fullWidth
            >
              <Box sx={{ p: 2 }}>
                <Typography
                  variant="h6"
                  className="urduNotationFont"
                  sx={{
                    textAlign: "center",
                    fontWeight: "bold",
                    mb: 2,
                    fontSize: "18px",
                  }}
                >
                  اجازت نامہ برائے آپریشن
                </Typography>

                <Typography
                  className="urduNotationFont"
                  sx={{
                    mb: 2,
                    textAlign: "right",
                    direction: "ltr",
                    fontSize: "14px",
                    lineHeight: "1.6",
                  }}
                >
                  میں میرا/مریض{" "}
                  <TextField
                    variant="standard"
                    size="small"
                    value={consentFormData.patientName}
                    onChange={e =>
                      handleConsentInputChange("patientName", e.target.value)
                    }
                    sx={{
                      width: "150px",
                      mx: 1,
                      "& .MuiInputBase-input": {
                        textAlign: "left",
                        fontSize: "14px",
                      },
                    }}
                  />{" "}
                  کے{" "}
                  <TextField
                    className="urduNotationFont"
                    variant="standard"
                    size="small"
                    value={consentFormData.operationName}
                    onChange={e =>
                      handleConsentInputChange("operationName", e.target.value)
                    }
                    sx={{
                      width: "150px",
                      mx: 1,
                      "& .MuiInputBase-input": {
                        textAlign: "left",
                        fontSize: "14px",
                      },
                    }}
                  />{" "}
                  آپریشن کروانے کے لئے تیار ہوں۔ مجھے آپریشن کے فائدہ، ممکنہ
                  پیچیدگیاں مثلاً{" "}
                  <TextField
                    className="urduNotationFont"
                    variant="standard"
                    size="small"
                    value={consentFormData.complications}
                    onChange={e =>
                      handleConsentInputChange("complications", e.target.value)
                    }
                    sx={{
                      width: "150px",
                      mx: 1,
                      "& .MuiInputBase-input": {
                        textAlign: "left",
                        fontSize: "14px",
                      },
                    }}
                  />{" "}
                  اور متبادل{" "}
                  <TextField
                    className="urduNotationFont"
                    variant="standard"
                    size="small"
                    value={consentFormData.alternatives}
                    onChange={e =>
                      handleConsentInputChange("alternatives", e.target.value)
                    }
                    sx={{
                      width: "150px",
                      mx: 1,
                      "& .MuiInputBase-input": {
                        textAlign: "left",
                        fontSize: "14px",
                      },
                    }}
                  />{" "}
                  کے بارے میں مکمل طور پر آگاہ کر دیا گیا ہے۔ یہ کہ آپریشن کا
                  مکمل خطرے سے خالی نہیں ہے۔ دوران آپریشن غیر متوقع حالات پیدا
                  ہوتی ہیں آپریشن کے بعد قدرتی سانس حاصل نہ ہونے کی صورت میں
                  مصنوعی سانس دلانے والی مشین (Ventilator) پر بھی ڈالا جا سکتا
                  ہے۔ ہم ڈاکٹر{" "}
                  <TextField
                    className="urduNotationFont"
                    variant="standard"
                    size="small"
                    value={consentFormData.doctorName}
                    onChange={e =>
                      handleConsentInputChange("doctorName", e.target.value)
                    }
                    sx={{
                      width: "150px",
                      mx: 1,
                      "& .MuiInputBase-input": {
                        textAlign: "left",
                        fontSize: "14px",
                      },
                    }}
                  />{" "}
                  کو آپریشن کی اجازت دیتے ہیں۔
                </Typography>

                {/* Signatures Section */}
                <Grid container spacing={2} sx={{ mt: 2 }}>
                  {/* Left Side - Signatures */}
                  <Grid item xs={6}>
                    {/* Patient/Guardian Signature */}
                    <Typography
                      className="urduNotationFont"
                      sx={{ textAlign: "right", fontSize: "14px", mb: 1 }}
                    >
                      :دستخط
                    </Typography>

                    {!consentSubmitted && (
                      <FingerprintCaptureControls
                        fingerprintDevice={fingerprintDevice}
                        detectingDevice={detectingDevice}
                        capturingFingerprint={capturingFingerprint}
                        onDetect={() => detectDevice(true)}
                        onCapture={captureFingerprint}
                      />
                    )}

                    <Box
                      dir="ltr"
                      sx={{
                        position: "relative",
                        border: "1px solid #000",
                        borderRadius: "4px",
                        padding: "0px",
                        width: "250px",
                        height: "180px",
                        overflow: "hidden",
                        background:
                          consentSubmitted && consentFormData.signature
                            ? "#f5f5f5"
                            : "transparent",
                        mb: 2,
                      }}
                    >
                      {(consentSubmitted && consentFormData.signature) ||
                      (isFingerprintImage && consentFormData.signature) ? (
                        <>
                          <img
                            src={consentFormData.signature}
                            alt={isFingerprintImage ? "Fingerprint" : "Signature"}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              pointerEvents: "none",
                              background: "#fff",
                            }}
                          />
                          {!consentSubmitted && (
                            <Button
                              onClick={clearSignature}
                              sx={{
                                position: "absolute",
                                top: 8,
                                right: 8,
                                minWidth: "24px",
                                padding: 0,
                                backgroundColor: "rgba(255, 255, 255, 0.8)",
                                "&:hover": {
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                },
                              }}
                            >
                              <CancelIcon
                                sx={{ color: "#ff0000", fontSize: "20px" }}
                              />
                            </Button>
                          )}
                        </>
                      ) : (
                        <>
                          <SignatureCanvas
                            ref={signatureRef}
                            penColor="black"
                            backgroundColor="transparent"
                            onEnd={handleSignature}
                            dotSize={1}
                            minWidth={0.5}
                            maxWidth={1.5}
                            canvasProps={{
                              width: 250,
                              height: 180,
                              style: {
                                cursor: "crosshair",
                                display: "block",
                                touchAction: "none",
                                width: "100%",
                                height: "100%",
                              },
                            }}
                          />
                          <Button
                            onClick={clearSignature}
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              minWidth: "24px",
                              padding: 0,
                              backgroundColor: "rgba(255, 255, 255, 0.8)",
                              "&:hover": {
                                backgroundColor: "rgba(255, 255, 255, 1)",
                              },
                            }}
                          >
                            <CancelIcon
                              sx={{ color: "#ff0000", fontSize: "20px" }}
                            />
                          </Button>
                        </>
                      )}
                    </Box>

                    {/* Doctor Signature */}
                    <Typography
                      className="urduNotationFont"
                      sx={{
                        textAlign: "right",
                        fontSize: "14px",
                        mb: 1,
                      }}
                    >
                      : ڈاکٹر کے دستخط
                    </Typography>

                    {!consentSubmitted && (
                      <FingerprintCaptureControls
                        fingerprintDevice={doctorFingerprintDevice}
                        detectingDevice={detectingDoctorDevice}
                        capturingFingerprint={capturingDoctorFingerprint}
                        onDetect={() => detectDoctorDevice(true)}
                        onCapture={captureDoctorFingerprint}
                      />
                    )}

                    <Box
                      dir="ltr"
                      sx={{
                        position: "relative",
                        border: "1px solid #000",
                        borderRadius: "4px",
                        padding: "0px",
                        width: "250px",
                        height: "180px",
                        overflow: "hidden",
                        background:
                          consentSubmitted && doctorSignatureData
                            ? "#f5f5f5"
                            : "transparent",
                      }}
                    >
                      {(consentSubmitted && doctorSignatureData) ||
                      (isDoctorFingerprintImage && doctorSignatureData) ? (
                        <>
                          <img
                            src={doctorSignatureData}
                            alt={
                              isDoctorFingerprintImage
                                ? "Doctor Fingerprint"
                                : "Doctor Signature"
                            }
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              pointerEvents: "none",
                              background: "#fff",
                            }}
                          />
                          {!consentSubmitted && (
                            <Button
                              onClick={clearDoctorSignature}
                              sx={{
                                position: "absolute",
                                top: 8,
                                right: 8,
                                minWidth: "24px",
                                padding: 0,
                                backgroundColor: "rgba(255, 255, 255, 0.8)",
                                "&:hover": {
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                },
                              }}
                            >
                              <CancelIcon
                                sx={{ color: "#ff0000", fontSize: "20px" }}
                              />
                            </Button>
                          )}
                        </>
                      ) : (
                        <>
                          <SignatureCanvas
                            ref={doctorSignatureRef}
                            penColor="black"
                            backgroundColor="transparent"
                            onEnd={handleDoctorSignature}
                            dotSize={1}
                            minWidth={0.5}
                            maxWidth={1.5}
                            canvasProps={{
                              width: 250,
                              height: 180,
                              style: {
                                cursor: "crosshair",
                                display: "block",
                                touchAction: "none",
                                width: "100%",
                                height: "100%",
                              },
                            }}
                          />
                          <Button
                            onClick={clearDoctorSignature}
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              minWidth: "24px",
                              padding: 0,
                              backgroundColor: "rgba(255, 255, 255, 0.8)",
                              "&:hover": {
                                backgroundColor: "rgba(255, 255, 255, 1)",
                              },
                            }}
                          >
                            <CancelIcon
                              sx={{ color: "#ff0000", fontSize: "20px" }}
                            />
                          </Button>
                        </>
                      )}
                    </Box>
                  </Grid>

                  {/* Right Side - Patient Information */}
                  <Grid item xs={6}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        mb: 2,
                      }}
                    >
                      <TextField
                        variant="standard"
                        size="small"
                        value={consentFormData.signerName}
                        onChange={e =>
                          handleConsentInputChange("signerName", e.target.value)
                        }
                        sx={{
                          width: "200px",
                          mr: 1,
                          "& .MuiInputBase-input": {
                            textAlign: "left",
                            fontSize: "14px",
                          },
                        }}
                      />
                      <Typography
                        className="urduNotationFont"
                        sx={{ textAlign: "left", fontSize: "14px" }}
                      >
                        :نام
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        mb: 2,
                      }}
                    >
                      <TextField
                        variant="standard"
                        size="small"
                        value={consentFormData.relationship}
                        onChange={e =>
                          handleConsentInputChange(
                            "relationship",
                            e.target.value
                          )
                        }
                        sx={{
                          width: "200px",
                          mr: 1,
                          "& .MuiInputBase-input": {
                            textAlign: "left",
                            fontSize: "14px",
                          },
                        }}
                      />
                      <Typography
                        className="urduNotationFont"
                        sx={{ textAlign: "left", fontSize: "14px" }}
                      >
                        :والدیت/زوج/مریض سے رشتہ
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                      }}
                    >
                      <TextField
                        variant="standard"
                        size="small"
                        type="datetime-local"
                        value={consentFormData.dateTime}
                        onChange={e =>
                          handleConsentInputChange("dateTime", e.target.value)
                        }
                        sx={{
                          width: "220px",
                          mr: 1,
                          "& .MuiInputBase-input": {
                            textAlign: "left",
                            fontSize: "14px",
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                      <Typography
                        className="urduNotationFont"
                        sx={{ textAlign: "left", fontSize: "14px" }}
                      >
                        :تاریخ و وقت
                      </Typography>
                    </Box>
                    {/* Spacer to align with doctor signature */}
                    <Box sx={{ height: "16px" }} />
                    {/* Doctor Name - aligned with doctor signature */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                      }}
                    >
                      <TextField
                        variant="standard"
                        size="small"
                        value={consentFormData.doctorNameField || ""}
                        onChange={e =>
                          handleConsentInputChange(
                            "doctorNameField",
                            e.target.value
                          )
                        }
                        sx={{
                          width: "200px",
                          mr: 1,
                          "& .MuiInputBase-input": {
                            textAlign: "left",
                            fontSize: "14px",
                          },
                        }}
                      />
                      <Typography
                        className="urduNotationFont"
                        sx={{ textAlign: "left", fontSize: "14px" }}
                      >
                        :ڈاکٹر کا نام
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 2,
                    gap: 2,
                  }}
                >
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleConsentCancel}
                  >
                    Cancel
                  </Button>
                  {consentSubmitted ? (
                    <Button
                      variant="contained"
                      color="warning"
                      onClick={() => {
                        setConsentSubmitted(false);
                        setFormData((prev: any) => ({
                          ...prev,
                          patientSignature: "",
                          doctorSignature: "",
                        }));
                      }}
                    >
                      Edit
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleConsentSubmit}
                    >
                      Submit
                    </Button>
                  )}
                </Box>
              </Box>
            </Dialog>
          </div>
        </Grid>

        <Grid item md={2.4} sm={4} xs={6}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "12px",
              color: "#000",
            }}
          >
            History :{" "}
          </Typography>
          <CustomAutocomplete
            multiple
            options={allSymptoms}
            getOptionLabel={option => option?.symptomName}
            filterOptions={(options, { inputValue }) =>
              options?.filter((option: any) =>
                option?.symptomName
                  ?.toLowerCase()
                  ?.includes(inputValue?.toLowerCase())
              )
            }
            onChange={(event, newValue) =>
              handleSelectChangeSymptoms(event, newValue)
            }
            value={selectedSymptoms}
            placeholder="Select History"
            onTextFieldChange={event =>
              handleInputChange(event, event.target.value)
            }
            handleBlur={handleBlurSymptoms}
            onKeyPress={handleKeyPress}
            handleAddClick={handleAddButtonClick}
          />

          <Box mt={0.4} sx={{}}>
            <Box
              sx={{ display: "flex", flexWrap: "wrap", marginBottom: "5px" }}
            >
              {/* <Typography sx={{ fontSize: '10px', color: '#000', fontWeight: '500' }}>
                                {Array.isArray(selectedPrevSymptoms) && selectedPrevSymptoms?.flat()?.join(', ') || 'No Previous History'}
                            </Typography> */}
              <Typography
                sx={{ fontSize: "10px", color: "#000", fontWeight: "500" }}
              >
                {Array.isArray(selectedPrevSymptoms) &&
                  selectedPrevSymptoms?.slice(0, 2).join(", ")}
                {selectedPrevSymptoms?.length > 2 && (
                  <Tooltip
                    title={
                      Array.isArray(selectedPrevSymptoms) &&
                      selectedPrevSymptoms?.slice(2)?.join(", ")
                    }
                    arrow
                    placement="top"
                  >
                    <span style={{ cursor: "pointer", color: "#1976d2" }}>
                      +{selectedPrevSymptoms?.length - 2} more
                    </span>
                  </Tooltip>
                )}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                marginTop: "8px",
                background:
                  selectedSymptoms?.length > 0
                    ? "rgba(192, 192, 192, 0.22)"
                    : "",
                border: selectedSymptoms?.length > 0 ? "2px solid #D8D8D8" : "",
                p: 0.5,
                borderRadius: "12px",
                gap: 0.5,
              }}
            >
              {selectedSymptoms?.map((symptom, index) => (
                <Chip
                  key={index}
                  label={
                    typeof symptom === "string" ? symptom : symptom.symptomName
                  } // Check if the element is a string or object
                  onDelete={() => handleDeleteChipSymptoms(symptom)} // Use the object or string directly for deletion
                  sx={{
                    borderRadius: "8px",
                    background: "#fff",
                    fontSize: "12px",
                    height: "24px",
                    "&:hover": {
                      background: "#055FFC",
                      color: "#fff",
                      "& .MuiChip-deleteIcon": {
                        color: "#fff",
                      },
                      "& .MuiChip-icon": {
                        color: "#fff",
                      },
                    },
                  }}
                />
              ))}
            </Box>
          </Box>
        </Grid>
        <Grid item md={2.4} sm={4} xs={6}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "12px",
              color: "#000",
            }}
          >
            Examination :{" "}
          </Typography>
          <CustomAutocomplete
            multiple
            options={allSigns || []}
            value={selectedSigns || []}
            getOptionLabel={option => option?.signName}
            filterOptions={(options, { inputValue }) =>
              options?.filter((option: any) =>
                option?.signName
                  ?.toLowerCase()
                  ?.includes(inputValue.toLowerCase())
              )
            }
            onChange={(event, newValue) => {
              handleSelectChangeSign({
                target: {
                  value: newValue?.map((sign: any) => sign._id),
                },
              });
            }}
            placeholder="Examination"
            onTextFieldChange={event =>
              handleInputChangeSigns(event, event.target.value)
            }
            handleBlur={handleInputChangeSignsBlur}
            onKeyPress={handleKeyPressSigns}
            handleAddClick={handleAddButtonClickSigns}
          />
          <Box mt={0.4}>
            <Box
              sx={{ display: "flex", flexWrap: "wrap", marginBottom: "5px" }}
            >
              {/* <Typography sx={{ fontSize: '10px', color: '#000', fontWeight: '500' }}>
                                {selectedPrevSigns?.flat()?.join(', ') || 'No Previous Examinations'}
                            </Typography> */}
              <Typography
                sx={{ fontSize: "10px", color: "#000", fontWeight: "500" }}
              >
                {Array.isArray(selectedPrevSigns) &&
                  selectedPrevSigns?.slice(0, 2).join(", ")}
                {selectedPrevSymptoms?.length > 2 && (
                  <Tooltip
                    title={
                      Array.isArray(selectedPrevSigns) &&
                      selectedPrevSigns?.slice(2)?.join(", ")
                    }
                    arrow
                    placement="top"
                  >
                    <span style={{ cursor: "pointer", color: "#1976d2" }}>
                      +{selectedPrevSigns?.length - 2} more
                    </span>
                  </Tooltip>
                )}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                marginTop: "2px",
                background:
                  signNames?.length > 0 ? "rgba(192, 192, 192, 0.2)" : "",
                border: signNames?.length > 0 ? "2px solid #D8D8D8" : "",
                p: 0.5,
                borderRadius: "12px",
              }}
            >
              {signNames?.map((sign: any, index) => (
                <Chip
                  size="small"
                  key={index}
                  // label={sign}
                  label={typeof sign === "string" ? sign : sign.signName}
                  onDelete={() => handleDeleteChip(sign)}
                  sx={{
                    // margin: "2px",
                    borderRadius: "8px",
                    background: "#fff",
                    border: "1px solid rgba(0, 0, 0, 0.22)",
                    fontSize: "12px",
                    "&:hover": {
                      background: "#055FFC",
                      color: "#fff",
                      "& .MuiChip-deleteIcon": {
                        color: "#fff", // Change delete icon color on hover
                      },
                      "& .MuiChip-icon": {
                        color: "#fff", // Change icon color on hover if you have an icon
                      },
                    },
                  }}
                />
              ))}
            </Box>
          </Box>
        </Grid>
        <Grid item md={2.4} sm={4} xs={6}>
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "12px",
              color: "#000",
            }}
          >
            Prov. Diagnosis :{" "}
          </Typography>
          <CustomAutocomplete
            multiple
            options={allDiagnosis || []}
            value={selectedDiagnosis || []}
            onChange={(event, newValue) => {
              handleSelectChangeDiagnosis({
                target: {
                  value: newValue?.map((diag: any) => diag._id),
                },
              });
            }}
            getOptionLabel={option => option?.diagnosisName}
            filterOptions={(options, { inputValue }) =>
              options?.filter((option: any) =>
                option?.diagnosisName
                  ?.toLowerCase()
                  .includes(inputValue.toLowerCase())
              )
            }
            placeholder="Provisional Diagnosis/DD"
            onTextFieldChange={event =>
              handleInputChangeDiagnosis(event, event.target.value)
            }
            handleBlur={handleInputChangeDiagnosisBlur}
            onKeyPress={handleKeyPressDiagnosis}
            handleAddClick={handleAddButtonClickDiagnosis}
          />
          <Box sx={{ display: "flex", flexWrap: "wrap" }}>
            <Typography
              sx={{ fontSize: "10px", color: "#000", fontWeight: "500" }}
            >
              {otherTabsData?.finalDiagnosis && (
                <Tooltip title="Final Diagnosis" placement="top">
                  <span
                    style={{
                      background: "#FFCCCB",
                      fontSize: "10px",
                      padding: "2px",
                      color: "#000",
                    }}
                  >
                    {otherTabsData?.finalDiagnosis}
                  </span>
                </Tooltip>
              )}{" "}
              {prevSelectedDiagnosis?.slice(0, 2).join(", ")}
              {prevSelectedDiagnosis?.length > 2 && (
                <Tooltip
                  title={prevSelectedDiagnosis?.slice(2)?.join(", ")}
                  arrow
                  placement="top"
                >
                  <span style={{ cursor: "pointer", color: "#1976d2" }}>
                    +{prevSelectedDiagnosis?.length - 2} more
                  </span>
                </Tooltip>
              )}
            </Typography>
          </Box>

          <Box mt={0.4}>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                background:
                  diagnosisName?.length > 0 ? "rgba(192, 192, 192, 0.2)" : "",
                border: diagnosisName?.length > 0 ? "2px solid #D8D8D8" : "",
                p: 0.5,
                borderRadius: "12px",
              }}
            >
              {diagnosisName?.map((sign: any, index: any) => (
                <Chip
                  size="small"
                  key={index}
                  label={sign}
                  onDelete={() => handleDeleteChipDiagnosis(sign)}
                  sx={{
                    borderRadius: "8px",
                    background: "#fff",
                    border: "1px solid rgba(0, 0, 0, 0.22)",
                    fontSize: "12px",
                    "&:hover": {
                      background: "#055FFC",
                      color: "#fff",
                      "& .MuiChip-deleteIcon": {
                        color: "#fff",
                      },
                      "& .MuiChip-icon": {
                        color: "#fff",
                      },
                    },
                  }}
                />
              ))}
            </Box>
          </Box>
        </Grid>
        <Grid item md={2.4} sm={8} xs={6}>
          <Box display="flex" alignItems="center" flexWrap="wrap">
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData?.pre_Operation?.npo} // Boolean value (true or false)
                  onChange={e =>
                    handlePreOperationChange("npo", e.target.checked)
                  } // Passes true/false
                  color="primary"
                  size="small"
                />
              }
              label="NPO :"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: "12px",
                  fontWeight: "500",
                },
              }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData?.pre_Operation?.maintain_IV_Line} // Boolean value (true or false)
                  onChange={e =>
                    handlePreOperationChange(
                      "maintain_IV_Line",
                      e.target.checked
                    )
                  } // Passes true/false
                  color="primary"
                  size="small"
                />
              }
              label="Maintain IV Line :"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: "12px",
                  fontWeight: "500",
                },
              }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData?.pre_Operation?.prepare_Area} // Boolean value (true or false)
                  onChange={e =>
                    handlePreOperationChange("prepare_Area", e.target.checked)
                  } // Passes true/false
                  color="primary"
                  size="small"
                />
              }
              label="Shave & Prepare the Area Mark the Operation Site :"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: "12px",
                  fontWeight: "500",
                },
              }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData?.pre_Operation?.take_Special_Consent} // Boolean value (true or false)
                  onChange={e =>
                    handlePreOperationChange(
                      "take_Special_Consent",
                      e.target.checked
                    )
                  } // Passes true/false
                  color="primary"
                  size="small"
                />
              }
              label="Take Special Consent :"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: "12px",
                  fontWeight: "500",
                },
              }}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid container>
        <Typography sx={{ fontSize: "12px", fontWeight: "600" }}>
          {" "}
          Indoor medicine (Already taking):
        </Typography>
        <Grid item md={12} sm={12} xs={12}>
          <Box
            sx={{
              maxHeight: "100px",
              overflowY: "auto",
              "&::-webkit-scrollbar": {
                width: "5px",
              },
              "&::-webkit-scrollbar-track": {
                background: "transparent",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#888",
                borderRadius: "5px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "#555",
              },
            }}
          >
            <DynamicTable
              headers={[
                "SN",
                "Medicine",
                "Strength",
                "Route",
                "Frequency",
                "Duration",
                "Doctor Name",
                "Date & Time",
              ]}
              data={preMedicine?.map((item: any, index: any) => [
                index + 1,
                item?.name,
                item?.strength,
                (() => {
                  const route = routeAdm?.find(
                    (route: any) => route?._id === item?.routAdministrationId
                  );
                  return route ? route?.RA_Abbreviation : "-";
                })(),
                item?.frequency?.abr_notation,
                item?.duration,
                item?.doctorName || "-",
                item?.dateAndTime
                  ? dayjs(item?.dateAndTime).format("DD.MM.YYYY hh:mm A")
                  : "-",
              ])}
            />
          </Box>
        </Grid>
      </Grid>

      <Grid container sx={{ mt: 2 }}>
        <Typography sx={{ fontSize: "12px", fontWeight: "600", mb: 1 }}>
          {" "}
          Pre-OP medicine (Ordered by Surgeon) :
        </Typography>
        <Grid item md={12}>
          <Box>
            <MedicineDoses
              onMedicineDoses={handleMedicineDoses}
              medicineDataIfExist={medicineData}
              setMedicineData={setMedicineData}
              medicineData={medicineData}
              treatment={true}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PreSurgical;
